import { memo } from 'react';
import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { TextOverflow } from '@ardoq/popovers';
import { CreateComponentItemProps } from '../../components/PropTypes';
import { SelectItemContainer } from '../../components/Atoms';

const CreateComponentContainer = styled(FlexBox)`
  line-height: 30px;
  height: 30px;
  align-items: center;
  cursor: pointer;
`;

const SelectCreateComponentItem = memo(
  ({
    label,
    nodeId,
    containerClassNames,
    containerStyle,
    ariaAttributes,
  }: CreateComponentItemProps) => (
    <SelectItemContainer data-id={nodeId} className={containerClassNames}>
      <CreateComponentContainer
        style={containerStyle}
        role="treeitem"
        {...ariaAttributes}
      >
        <Icon iconName={IconName.ADD} iconSize={IconSize.SMALL} />
        <TextOverflow popoverAcceptsMouse={false}>{label}</TextOverflow>
      </CreateComponentContainer>
    </SelectItemContainer>
  )
);

export { SelectCreateComponentItem };
